module.exports = __webpack_public_path__ + "static/media/nebbixicon.da0c7807.svg";